export const TYPE_RULES = {
  AUTHOR: {
    rules: 'required|not_null',
  },
  STRING: {
    rules: '',
  },
  DATE: {
    rules: 'date_validation',
  },
  NUMBER: {
    rules: 'decimal_validation',
  },
  VAT_ID: {
    rules: '',
  },
  CONSTANT: {
    rules: '',
  },
  CURRENCY: {
    rules: '',
  },
};

export const TYPE_HINTS = {
  DATE: 'Date format: YYYY-MM-DD',
  NUMBER: 'Number format, decimal or integer',
};

export const TRAINING_STATUSES = {
  IN_TRAINING: 'Models in training',
  TRAINING_FINISHED: 'Models trained',
  TRAINING_FAILED: 'Models training failed',
  TRAINING_ERROR: 'Error training model',
  UNTRAINED: 'Models not trained yet',
  DELETING: 'Deleting',
  DELETING_FAILED: 'Deleting failed',
  LOCKED: 'Model locked',
};

export const ACCOUNTLESS_INVOICE_STATUSES = {
  DATA_EXPIRED: 'Data expired',
  DATA_READY: 'Data is ready',
};

export const OCR_ENGINES = [
  {
    text: 'Default - Latin alphabet documents',
    value: '1',
  },
  {
    text: 'Multiple character sets - Latin, Cyrillic, Arabic',
    value: '2',
  },
];

export const DOCUMENT_TYPE_PRESETS = {
  SIMPLE_INVOICE: {
    ocr_engine: '1',
    name: 'simple-invoice',
    display_name: 'Simple invoice',
    fields: [
      {
        type: 'AUTHOR',
        name: 'supplier_name',
      },
      {
        name: 'invoice_number',
        type: 'STRING',
      },
      {
        name: 'pay_due_date',
        type: 'DATE',
      },
      {
        name: 'issue_date',
        type: 'DATE',
      },
      {
        name: 'total_amount',
        type: 'NUMBER',
      },
    ],
    line_items: [],
    plugins: [],
    labels: [
      {
        name: 'Start here',
        color: 'success',
      },
    ],
    description: 'A simple invoice with enough fields to get you started!',
    preset: true,
  },
  META_DATA_INVOICE: {
    ocr_engine: '1',
    name: 'metadata-invoice',
    display_name: 'Metadata invoice',
    fields: [
      {
        type: 'AUTHOR',
        name: 'supplier_name',
      },
      {
        name: 'receiver_name',
        type: 'STRING',
      },
      {
        name: 'invoice_number',
        type: 'STRING',
      },
      {
        name: 'purchase_order_number',
        type: 'STRING',
      },
      {
        name: 'pay_due_date',
        type: 'DATE',
      },
      {
        name: 'issue_date',
        type: 'DATE',
      },
      {
        name: 'total_amount',
        type: 'NUMBER',
      },
    ],
    line_items: [],
    plugins: [],
    description: 'A general invoice with additional header fields.',
    label: '',
    labelColor: '',
    preset: true,
  },
  VAT_INVOICE: {
    ocr_engine: '1',
    name: 'vat-invoice',
    display_name: 'Vat invoice',
    fields: [
      {
        type: 'AUTHOR',
        name: 'supplier_name',
      },
      {
        name: 'receiver_name',
        type: 'STRING',
      },
      {
        name: 'invoice_number',
        type: 'STRING',
      },
      {
        name: 'purchase_order_number',
        type: 'STRING',
      },
      {
        name: 'pay_due_date',
        type: 'DATE',
      },
      {
        name: 'issue_date',
        type: 'DATE',
      },
      {
        name: 'total_amount',
        type: 'NUMBER',
      },
      {
        name: 'net_amount',
        type: 'NUMBER',
      },
    ],
    line_items: [],
    plugins: [
      {
        name: 'VatRateNetPlugin',
        config: {
          net_amount_field: 'net_amount',
          gross_amount_field: 'total_amount',
        },
      },
    ],
    description: 'A general invoice with vat rate extraction support.',
    labels: [
      {
        name: 'Advanced',
        color: 'primary',
      },
    ],
    preset: true,
  },
  INVOICE_WITH_LINE_ITEMS: {
    ocr_engine: '1',
    name: 'line-item-invoice',
    display_name: 'Line item invoice',
    fields: [
      {
        type: 'AUTHOR',
        name: 'supplier_name',
      },
      {
        name: 'receiver_name',
        type: 'STRING',
      },
      {
        name: 'invoice_number',
        type: 'STRING',
      },
      {
        name: 'purchase_order_number',
        type: 'STRING',
      },
      {
        name: 'pay_due_date',
        type: 'DATE',
      },
      {
        name: 'issue_date',
        type: 'DATE',
      },
      {
        name: 'total_amount',
        type: 'NUMBER',
      },
    ],
    line_items: [
      { name: 'product_number', type: 'STRING' },
      { name: 'product_description', type: 'STRING' },
      { name: 'quantity', type: 'NUMBER' },
      { name: 'price', type: 'NUMBER' },
    ],
    plugins: [],
    description: 'A complex invoice with metadata and line item fields.',
    labels: [
      {
        name: 'Advanced',
        color: 'primary',
      },
    ],
    preset: true,
  },
  TRANSPORT_REPORT: {
    ocr_engine: '1',
    name: 'transport-report',
    display_name: 'Transport report',
    fields: [
      {
        type: 'AUTHOR',
        name: 'supplier_name',
      },
      {
        name: 'receiver_name',
        type: 'STRING',
      },
      {
        name: 'from_address',
        type: 'STRING',
      },
      {
        name: 'to_address',
        type: 'STRING',
      },
      {
        name: 'document_number',
        type: 'STRING',
      },
      {
        name: 'shipment_number',
        type: 'STRING',
      },
      {
        name: 'purchase_order_number',
        type: 'STRING',
      },
      {
        name: 'issue_date',
        type: 'DATE',
      },
      {
        name: 'load_weight',
        type: 'NUMBER',
      },
      {
        name: 'total_amount',
        type: 'NUMBER',
      },
    ],
    line_items: [
      { name: 'product_number', type: 'STRING' },
      { name: 'product_description', type: 'STRING' },
      { name: 'quantity', type: 'NUMBER' },
      { name: 'weight', type: 'NUMBER' },
      { name: 'number_of_boxes', type: 'NUMBER' },
    ],
    plugins: [],
    description:
      'Transportation report document with load information extraction and general logistics information.',
    labels: [
      {
        name: 'Logistics',
        color: 'primary',
      },
    ],
    preset: true,
  },
  GENERAL_META_DATA_INVOICE: {
    ocr_engine: '8',
    name: 'general-meta-data-invoice',
    display_name: 'General metadata invoice',
    fields: [
      {
        name: 'supplier_name',
        type: 'AUTHOR',
        description: 'Name of the supplier',
        allow_multiple_values: false,
      },
      {
        name: 'supplier_vat_id',
        type: 'STRING',
        description: 'VAT ID of the supplier',
        allow_multiple_values: false,
      },
      {
        name: 'buyer_vat_id',
        type: 'STRING',
        description: 'VAT ID of the buyer',
        allow_multiple_values: false,
      },
      {
        name: 'buyer_name',
        type: 'STRING',
        description: 'Name of the buyer',
        allow_multiple_values: false,
      },
      {
        name: 'invoice_number',
        type: 'STRING',
        description: 'Unique number of the invoice',
        allow_multiple_values: false,
      },
      {
        name: 'payment_reference',
        type: 'STRING',
        description: 'Payment reference number for bank transfer',
        allow_multiple_values: false,
      },
      {
        name: 'invoice_date',
        type: 'DATE',
        description: 'Date of the invoice. Format it as YYYY-MM-DD',
        allow_multiple_values: false,
      },
      {
        name: 'pay_until',
        type: 'DATE',
        description: 'Payment deadline for invoice. Format it as YYYY-MM-DD',
        allow_multiple_values: false,
      },
      {
        name: 'service_provided_date',
        type: 'DATE',
        description:
          'Date of service for invoice items. Format it as YYYY-MM-DD',
        allow_multiple_values: false,
      },
      {
        name: 'amount_net',
        type: 'NUMBER',
        description: 'Net amount on the invoice',
        allow_multiple_values: false,
      },
      {
        name: 'amount_vat',
        type: 'NUMBER',
        description: 'VAT amount on the invoice',
        allow_multiple_values: false,
      },
      {
        name: 'amount_gross',
        type: 'NUMBER',
        description: 'Gross amount on the invoice',
        allow_multiple_values: false,
      },
      {
        name: 'iban',
        type: 'STRING',
        description: 'IBAN numbers for invoice payment',
        allow_multiple_values: true,
      },
      {
        name: 'purpose_code',
        type: 'STRING',
        description: 'Purpose code for the invoice payment',
        allow_multiple_values: false,
      },
      {
        name: 'purchasing_order',
        type: 'STRING',
        description: 'Purchasing orders on the invoice',
        allow_multiple_values: true,
      },
      {
        name: 'payment_currency',
        type: 'STRING',
        description: 'Currency on the invoice',
        allow_multiple_values: false,
      },
    ],
    line_items: [],
    plugins: [],
    description: 'General meta data invoice template.',
    labels: [
      {
        name: 'General model',
        color: 'lime',
      },
    ],
    pretrained_model: true,
  },
  GENERAL_LINE_ITEM_INVOICE: {
    ocr_engine: '7',
    name: 'general-line-item-invoice',
    display_name: 'General line item invoice',
    fields: [
      {
        name: 'supplier_name',
        type: 'AUTHOR',
        description: 'Name of the supplier',
        allow_multiple_values: false,
      },
      {
        name: 'supplier_vat_id',
        type: 'STRING',
        description: 'VAT ID of the supplier',
        allow_multiple_values: false,
      },
      {
        name: 'buyer_vat_id',
        type: 'STRING',
        description: 'VAT ID of the buyer',
        allow_multiple_values: false,
      },
      {
        name: 'buyer_name',
        type: 'STRING',
        description: 'Name of the buyer',
        allow_multiple_values: false,
      },
      {
        name: 'invoice_number',
        type: 'STRING',
        description: 'Unique number of the invoice',
        allow_multiple_values: false,
      },
      {
        name: 'payment_reference',
        type: 'STRING',
        description: 'Payment reference number for bank transfer',
        allow_multiple_values: false,
      },
      {
        name: 'invoice_date',
        type: 'DATE',
        description: 'Date of the invoice. Format it as YYYY-MM-DD',
        allow_multiple_values: false,
      },
      {
        name: 'pay_until',
        type: 'DATE',
        description: 'Payment deadline for invoice. Format it as YYYY-MM-DD',
        allow_multiple_values: false,
      },
      {
        name: 'service_provided_date',
        type: 'DATE',
        description:
          'Date of service for invoice items. Format it as YYYY-MM-DD',
        allow_multiple_values: false,
      },
      {
        name: 'amount_net',
        type: 'NUMBER',
        description: 'Net amount on the invoice',
        allow_multiple_values: false,
      },
      {
        name: 'amount_vat',
        type: 'NUMBER',
        description: 'VAT amount on the invoice',
        allow_multiple_values: false,
      },
      {
        name: 'amount_gross',
        type: 'NUMBER',
        description: 'Gross amount on the invoice',
        allow_multiple_values: false,
      },
      {
        name: 'iban',
        type: 'STRING',
        description: 'IBAN numbers for invoice payment',
        allow_multiple_values: true,
      },
      {
        name: 'purpose_code',
        type: 'STRING',
        description: 'Purpose code for the invoice payment',
        allow_multiple_values: false,
      },
      {
        name: 'purchasing_order',
        type: 'STRING',
        description: 'Purchasing orders on the invoice',
        allow_multiple_values: true,
      },
      {
        name: 'payment_currency',
        type: 'STRING',
        description: 'Currency on the invoice',
        allow_multiple_values: false,
      },
    ],
    line_items: [
      {
        name: 'item_code',
        type: 'STRING',
        description: 'Unique identifier of the item',
      },
      {
        name: 'item_description',
        type: 'STRING',
        description: 'Descriptive name of the item',
      },
      {
        name: 'unit',
        type: 'STRING',
        description: 'Unit of measurement (e.g., pcs, kg, hours) of the item',
      },
      {
        name: 'net_amount',
        type: 'NUMBER',
        description: 'Total price of the item before tax',
      },
      {
        name: 'vat_amount',
        type: 'NUMBER',
        description: 'Tax amount of the item',
      },
      {
        name: 'gross_amount',
        type: 'NUMBER',
        description: 'Total price of item including tax',
      },
      {
        name: 'discount_percentage',
        type: 'NUMBER',
        description: 'Discount percentage applied of the item',
      },
      {
        name: 'discount',
        type: 'NUMBER',
        description: 'Discount amount applied of the item',
      },
      {
        name: 'unit_price',
        type: 'NUMBER',
        description: 'Price per unit of the item',
      },
      {
        name: 'quantity',
        type: 'NUMBER',
        description: 'Number of units of the item',
      },
      {
        name: 'vat_rate',
        type: 'NUMBER',
        description: 'VAT rate of the item',
      },
    ],
    plugins: [],
    description: 'General line item invoice template.',
    labels: [
      {
        name: 'General model',
        color: 'lime',
      },
    ],
    pretrained_model: true,
  },
  GENERAL_DELIVERY_NOTE: {
    ocr_engine: '7',
    name: 'general-delivery-note',
    display_name: 'General delivery note',
    fields: [
      {
        name: 'supplier_name',
        type: 'AUTHOR',
        description: 'Name of the supplier or selling entity',
        allow_multiple_values: false,
      },
      {
        name: 'supplier_address',
        type: 'STRING',
        description: 'Street address of the supplier',
        allow_multiple_values: false,
      },
      {
        name: 'supplier_postal_code',
        type: 'STRING',
        description: 'Postal or ZIP code of the supplier',
        allow_multiple_values: false,
      },
      {
        name: 'supplier_city',
        type: 'STRING',
        description: 'City of the supplier',
        allow_multiple_values: false,
      },
      {
        name: 'supplier_country',
        type: 'STRING',
        description: 'Country of the supplier',
        allow_multiple_values: false,
      },
      {
        name: 'supplier_vat_id',
        type: 'STRING',
        description: 'Unique identifier for the supplier',
        allow_multiple_values: false,
      },
      {
        name: 'customer_name',
        type: 'STRING',
        description: 'Name of the customer or buying entity',
        allow_multiple_values: false,
      },
      {
        name: 'customer_address',
        type: 'STRING',
        description: 'Full address of the customer',
        allow_multiple_values: false,
      },
      {
        name: 'document_number',
        type: 'STRING',
        description: 'Unique identifier for the document',
        allow_multiple_values: false,
      },
      {
        name: 'document_date',
        type: 'DATE',
        description: 'Date the document was issued',
        allow_multiple_values: false,
      },
      {
        name: 'supplier_email',
        type: 'STRING',
        description: 'Email address of the supplier',
        allow_multiple_values: false,
      },
    ],
    line_items: [
      {
        name: 'item_code',
        type: 'STRING',
        description: 'Unique identifier for the product or service',
      },
      {
        name: 'item_quantity',
        type: 'NUMBER',
        description: 'Number of units of the item',
      },
      {
        name: 'item_description',
        type: 'STRING',
        description: 'Description/name of the product or service',
      },
      {
        name: 'item_unit',
        type: 'STRING',
        description: 'Unit of measurement of the item (e.g., pcs, kg, hours)',
      },
    ],
    plugins: [],
    description: 'General delivery note template.',
    labels: [
      {
        name: 'General model',
        color: 'lime',
      },
    ],
    pretrained_model: true,
  },
  CUSTOM_DOCUMENT: {
    ocr_engine: '1',
    name: 'custom-document',
    display_name: 'Custom document',
    fields: [
      {
        type: 'AUTHOR',
        name: 'supplier_name',
      },
    ],
    line_items: [],
    plugins: [],
    labels: [
      {
        name: 'Advanced',
        color: 'info',
      },
      {
        name: 'Custom',
        color: 'blue',
      },
    ],
    description: 'Custom document type with your custom defined fields',
    custom: true,
  },
  CREATE_FROM_EXISTING: {
    ocr_engine: '1',
    name: 'create-from-existing',
    display_name: 'Create from existing',
    fields: [
      {
        type: 'AUTHOR',
        name: 'supplier_name',
      },
    ],
    line_items: [],
    plugins: [],
    labels: [
      {
        name: 'Advanced',
        color: 'info',
      },
      {
        name: 'Custom',
        color: 'blue',
      },
    ],
    description:
      'Create a new document type with the same configuration as your existing ' +
      'one with all the trained models included.',
    custom: true,
  },
};

export const NON_CONFIGURABLE_DOCUMENT_TYPES = [
  'general-meta-data-invoice',
  'general-line-item-invoice',
  'general-delivery-note',
];

export const EU_COUNTRIES = [
  'AT',
  'BE',
  'BG',
  'CY',
  'CZ',
  'DE',
  'DK',
  'EE',
  'EL',
  'ES',
  'FI',
  'FR',
  'XI',
  'HR',
  'HU',
  'IE',
  'IT',
  'LT',
  'LU',
  'LV',
  'MT',
  'NL',
  'PL',
  'PT',
  'RO',
  'SE',
  'SI',
  'SK',
  'GR',
];
